import { makeStyles } from '@material-ui/core/styles';
import { dashBorderSVG } from '~/modules/resourcing/common/components';

const useStyles = makeStyles(theme => ({
  root: {
    position: 'absolute',
    height: theme.spacing(3),
    userSelect: 'none',
    '&:hover $resizeHandle': {
      opacity: 1
    }
  },
  container: {
    width: '100%',
    ...theme.typography.caption,
    cursor: 'default',
    height: `${theme.spacing(3)}px`,
    border: `2px dashed ${theme.palette.grey[700]}`,
    borderImage: `url(${dashBorderSVG}) 2 repeat`,
    borderRadius: theme.spacing(0.25)
  },
  containerNoStart: { borderLeft: 'none' },
  containerNoEnd: { borderRight: 'none' },
  editableContainer: {
    cursor: 'move',
    transition: theme.transitions.create('box-shadow', {
      easing: theme.transitions.easing.easeInOut,
      duration: theme.transitions.duration.short
    }),
    '&:hover': {
      boxShadow: theme.shadows[4]
    }
  },
  continerBreakdown: {
    fontSize: theme.typography.pxToRem(10)
  },
  containerToBeHired: {
    borderRadius: 0,
    backgroundColor: theme.palette.resourceRequest.toBeHired.main
  },
  containerRejected: {
    borderRadius: 0,
    backgroundColor: theme.palette.resourceRequest.requestRejected.main,
    '& $resizeIcon': {
      color: theme.palette.getContrastText(
        theme.palette.resourceRequest.resourceRejected.main
      )
    }
  },
  resizeHandle: {
    position: 'absolute',
    top: 0,
    bottom: 0,
    width: theme.spacing(2),
    cursor: 'ew-resize',
    border: 'solid 2px transparent',
    opacity: 0,
    overflow: 'hidden',
    transition: theme.transitions.create(['opacity'], {
      easing: theme.transitions.easing.easeInOut,
      duration: theme.transitions.duration.shortest
    })
  },
  resizeHandleStart: {
    left: 0
  },
  resizeHandleEnd: {
    left: `calc(100% - ${theme.spacing(2)}px)`
  },
  resizeIcon: {
    margin: theme.spacing(-0.25, -0.75)
  },
  disablePointerEvents: {
    pointerEvents: 'none'
  }
}));

export default useStyles;
